(() => {
  'use strict';

  const copyText = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    textarea.remove();
  };

  const initCopyButtons = (root) => {
    root.querySelectorAll('[data-zy-copy-link]').forEach((button) => {
      if (button.dataset.zyBound === 'true') return;
      button.dataset.zyBound = 'true';

      button.addEventListener('click', async () => {
        const label = button.querySelector('[data-zy-copy-label]');
        const originalLabel = label ? label.textContent : '';
        const url = button.dataset.url || window.location.href;

        try {
          await copyText(url);
          button.classList.add('is-copied');
          if (label) label.textContent = 'Link copied';

          window.setTimeout(() => {
            button.classList.remove('is-copied');
            if (label) label.textContent = originalLabel;
          }, 1800);
        } catch (error) {
          console.warn('Unable to copy the article link.', error);
        }
      });
    });
  };

  const initNativeShare = (root) => {
    root.querySelectorAll('[data-zy-native-share]').forEach((button) => {
      if (!navigator.share) {
        button.hidden = true;
        return;
      }

      button.hidden = false;
      if (button.dataset.zyBound === 'true') return;
      button.dataset.zyBound = 'true';

      button.addEventListener('click', async () => {
        try {
          await navigator.share({
            title: button.dataset.title || document.title,
            url: button.dataset.url || window.location.href
          });
        } catch (error) {
          if (error && error.name !== 'AbortError') {
            console.warn('Unable to share this article.', error);
          }
        }
      });
    });
  };

  const initReadingProgress = () => {
    const progress = document.querySelector('[data-zy-reading-progress]');
    const articleContent = document.querySelector('.zy-article__content');

    if (!progress || !articleContent || progress.dataset.zyBound === 'true') return;
    progress.dataset.zyBound = 'true';

    const bar = progress.querySelector('span');
    let ticking = false;

    const update = () => {
      const contentTop = articleContent.getBoundingClientRect().top + window.scrollY;
      const start = contentTop - window.innerHeight * 0.28;
      const readableDistance = Math.max(
        articleContent.offsetHeight - window.innerHeight * 0.5,
        1
      );
      const amount = Math.min(
        Math.max((window.scrollY - start) / readableDistance, 0),
        1
      );

      if (bar) bar.style.transform = `scaleX(${amount})`;
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  };

  const init = (root = document) => {
    initCopyButtons(root);
    initNativeShare(root);
    initReadingProgress();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target || document);
  });
})();
